export default __webpack_public_path__ + "static/media/edx.3aa39469.jpg";